module.exports = __webpack_public_path__ + "static/media/BG-DecorationHome.60f1c3a5.png";